import { unset } from 'cerebral/operators'
import { props, state, string } from 'cerebral/tags'
import { deleteResource } from '../actions/manipulateResource'
import spliceFileResource from '../factories/spliceFileResource'

export default [
  unset(state`${props`path`}`),
  spliceFileResource(string`resources.${props`type`}`),
  deleteResource
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/deleteResource.js